import type { ConnectedPosition } from '@angular/cdk/overlay';

import type { Observable } from 'rxjs';

import type {
  SymbolVirtualScrollRow,
  EmojiListNavigationKeys,
  SymbolSelectItem,
} from '@core/symbol-data';

import type { OverlayPosition } from '../../editor/types';
import { EditorEvent } from '../../editor/types';

export interface EmojiOpenOptions {
  withSearchInput?: boolean;
  searchValue?: string;
  preferredPositions?: ConnectedPosition[];
  dataSources: ['emojis'];
}

export abstract class EmojiPluginEvent extends EditorEvent {
  protected constructor(type: string) {
    super('EmojiPlugin', type);
  }
}

export class EmojiPluginPickerBeforeOpen extends EmojiPluginEvent {
  constructor() {
    super('pickerOpen');
  }
}

export class EmojiPluginPickerClose extends EmojiPluginEvent {
  constructor() {
    super('pickerClose');
  }
}

export type EmojiEditorPluginEvents = EmojiPluginPickerBeforeOpen | EmojiPluginPickerClose;

export interface EmojiListController {
  open: <T extends EmojiOpenOptions>(
    position: OverlayPosition,
    options: T,
  ) => {
    select$: Observable<Extract<SymbolSelectItem, { dataSourceId: T['dataSources'][number] }>>;
    element: HTMLElement;
    backdropClick$: Observable<MouseEvent>;
  };
  update: (prop: 'searchValue', value: string) => void;
  saveUsedEmoji: (emojiCode: string) => void;
  setData: (data: SymbolVirtualScrollRow) => void;
  close: () => void;
  updatePosition: (position: OverlayPosition) => void;
  isOpen: () => boolean;
  handleKey: (key: EmojiListNavigationKeys) => void;
  dataSourceHasResults: (dataSourceId: 'emojis', query: string) => boolean;
}
